// document.addEventListener('DOMContentLoaded', function() {
(function() {
  const animatedSections = document.querySelectorAll('[data-animation]');

  if (window.innerWidth < 767) {
    return;
  }

  window.addEventListener('scroll', () => {
    animatedSections.forEach((el) => {
      const path = el.getAttribute('data-animation');
      if (!path || el.hasAttribute('loaded')) return;
      const rect = el.getBoundingClientRect();
      if (rect.top > window.innerHeight) return;
      el.setAttribute('loaded', '');
      const aspect = el.getAttribute('data-animation-ratio');
      const container = document.createElement('div');
      container.className = 'lottie-animation';
      el.prepend(container);
      bodymovin.loadAnimation({
        container: container,
        renderer: 'canvas',
        loop: true,
        autoplay: true,
        path: path,
        rendererSettings: {
          preserveAspectRatio: aspect || 'xMidYMid slice',
        },
      });
    });
  }, false);

  window.dispatchEvent(new Event('scroll'));
})();
// });
